
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96 96"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.001 87.999h80","fill":"#292d32","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M68.001 8.001h-40c-12 0-16 7.16-16 16v64h72v-64c0-8.84-4-16-16-16zM28 66h12M55.999 66h12M28 48h12M55.999 48h12M28 30h12M55.999 30h12","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5"}})])
          )
        }
      }
    